import { render } from "./PlayList.vue?vue&type=template&id=ed48ffea&scoped=true"
import script from "./PlayList.vue?vue&type=script&lang=js"
export * from "./PlayList.vue?vue&type=script&lang=js"

import "./PlayList.vue?vue&type=style&index=0&id=ed48ffea&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed48ffea"]])

export default __exports__